/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_Who_AInputs */

const en_price_page_faq_who_a = /** @type {(inputs: Price_Page_Faq_Who_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The specialist you book, directly. They set the prices, packs and cancellation rules, and we handle the payment.`)
};

const pl_price_page_faq_who_a = /** @type {(inputs: Price_Page_Faq_Who_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpośrednio specjaliście, u którego rezerwujesz. To on ustala ceny, pakiety i zasady odwołania, a my obsługujemy płatność.`)
};

/**
* | output |
* | --- |
* | "The specialist you book, directly. They set the prices, packs and cancellation rules, and we handle the payment." |
*
* @param {Price_Page_Faq_Who_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_who_a = /** @type {((inputs?: Price_Page_Faq_Who_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_Who_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_who_a(inputs)
	return en_price_page_faq_who_a(inputs)
});